module.exports = __webpack_public_path__ + "img/second_.2a481dad.jpg";